import { Globe, Video } from "lucide-react";
import { Link } from "react-router-dom";

import { Card } from "@/components/card";
import { RecordingThumbnail } from "@/features/recordings/components/recording-thumbnail";
import { PublicPlaylist } from "@classview/shared-types";

import { PlaylistItemActions } from "./playlist-item-actions";

type PlaylistCardProps = {
  playlist: PublicPlaylist;
};

export function PlaylistCard({ playlist }: PlaylistCardProps) {
  const firstRecordingWithThumbnail = playlist.recordings.find(
    (recording) => recording.imageURL,
  );

  const thumbnail = firstRecordingWithThumbnail?.imageURL;
  return (
    <Card className="flex flex-1 flex-col" as="article">
      <Link
        className="dark group relative block"
        to={`/recordings/playlists/${playlist.id}`}
      >
        <RecordingThumbnail imageURL={thumbnail} />
      </Link>
      <Card.Content className="flex h-full flex-1 flex-col items-stretch pt-3">
        <div className="flex flex-row justify-between">
          <div className="text-md font-semibold text-foreground">
            {playlist.name}
          </div>
          <PlaylistItemActions playlist={playlist} />
        </div>
        <div className="mt-auto flex flex-row items-center">
          <dl className="flex flex-row items-center space-x-3">
            <div className="flex items-center">
              <dt className="sr-only">Recordings</dt>
              <dd className="flex items-center text-sm text-muted">
                <Video
                  className="mr-1 size-3 text-card-foreground"
                  aria-hidden={true}
                />
                {playlist.recordings.length} Video
                {playlist.recordings.length > 1 ? "s" : ""}
              </dd>
            </div>
            {playlist.isPublic && (
              <div className="flex items-center">
                <dt className="sr-only">Public video</dt>
                <dd className="flex items-center text-sm text-muted">
                  <Globe
                    className="mr-1 size-3 text-card-foreground"
                    aria-hidden={true}
                  />
                  Public
                </dd>
              </div>
            )}
          </dl>
        </div>
      </Card.Content>
    </Card>
  );
}
